module.exports = __webpack_public_path__ + "static/img/Katherine.3f8408e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Katherine.jpg
// module id = gmpz
// module chunks = 5